// extracted by mini-css-extract-plugin
export default {"brandPromo":"DH-z","carousel":"EH-z"};